import { render, staticRenderFns } from "./ClientFamilyModal.vue?vue&type=template&id=23d1b80d&scoped=true&"
import script from "./ClientFamilyModal.vue?vue&type=script&lang=js&"
export * from "./ClientFamilyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1b80d",
  null
  
)

export default component.exports